import { render } from "./NewAccountHeader.vue?vue&type=template&id=db76ebd0&scoped=true"
import script from "./NewAccountHeader.vue?vue&type=script&lang=js"
export * from "./NewAccountHeader.vue?vue&type=script&lang=js"

import "./NewAccountHeader.vue?vue&type=style&index=0&id=db76ebd0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db76ebd0"]])

export default __exports__